export default {
  black: '#000000',
  abnBlack: '#222222',
  abnNeutral10: '#7D7D7D',
  abnNeutral20: '#F3F3F3',
  abnNeutral50: '#F9F9F9',
  abnNeutral55: '#E9E9E9',
  abnNeutral75: '#CCCCCC',
  abnNeutral80: '#c1c1c1',
  abnNeutral90: '#909090',
  abnNeutral200: '#959595',
  abnNeutral300: '#808080',
  abnNeutral400: '#666666',
  abnNeutral500: '#4D4D4D',
  abnNeutral610: '#616161',
  abnNeutral670: '#222222',
  white: '#FFFFFF',
  abnInverse: '#f3f3f3',
  abnGradient: 'linear-gradient(90deg, #005E5D 0%, #00857A 100%)',
  abnLinkGreenB: '#00857a',
  abnYellow: '#FFD200',
  abnYellow400: '#F3C000',
  abnYellow500: '#E5B400',
  abnYellowToneFour: '#FDF2CC',
  abnButtonGreen: '#004343',
  abnZachtgeel: '#FFEA8F',
  amber: '#f3a400',
  abnIceGrey: '#D8F0F0',
  abnGrey620: '#616161',
  abnGreen100: '#37ABA1',
  abnGreen200: '#00857A',
  abnGreen300: '#00716B',
  abnGreen400: '#005E5D',
  abnGreen500: '#004C4C',
  abnGreen600: '#003737',
  abnGreen670: '#002929',
  abnGreen700: '#001E1E',
  abnGreen50: '#EDF7F7',
  abnGreen55: '#D8F0EF',
  abnGreen60: '#E8F1F0',
  abnGreen65: '#ADE0DF',
  abnGreen75: '#86D1CD',
  abnMutedGreen: '#C0D1D0',
  abnMutedGreen50: '#F2F7F7',
  abnMutedGreen55: '#E9F0F0',
  abnMutedGreen65: '#D3E0E0',
  abnMutedGreen100: '#91ABA9',
  abnMutedGreen200: '#668582',
  abnMutedGreen300: '#4F706F',
  abnMutedGreen400: '#3C5E5E',
  abnMutedGreen500: '#2D4D4D',
  abnNeutralsN65: '#DEDEDE',
  abnNeutralsN100: '#B3B3B3',
  abnDarkBlue01: '#0044AA',
  abnBlue01: '#005CDE',
  abnPrivacy400: '#6927A3',
  abnInfo400: '#0070E9',
  abnPositive400: '#528217',
  abnNegative400: '#D21B02',
  abnLightBlue: '#5E9ED6',
  abnInformative: '#E3F0F7',
  abnGradientRippleHeaderHorizontal:
    'linear-gradient(90deg, #004040 0%, #004040 45%,#014c4c 55%, #014c4c 100%)',
  abnGradientRippleHeaderVerticalMobile:
    'linear-gradient(#154746, transparent)',
  abnGradientRippleHeaderVerticalDesktop:
    'linear-gradient(#003c3b, transparent)',
};
